import { BooleanNumber } from 'src/app/common/utilities/enums/boolean-number.enum';
import { FileDTO } from './file.dto';

export interface Conversation {
  id: number;
  user_id: number;
  title: string;
  created_at: number;
  updated_at: number;
  glai_stream_id: string;
}

export interface ConversationResponse {
  item: Conversation;
}

export interface TokenData {
  content: string;
  message_id: string;
  timestamp: string;
  model_id: string | null;
  input_tokens: number | null;
  output_tokens: number | null;
}

export interface ChatMessage {
  id: string;
  content: string;
  rawContent?: string;
  thinking?: string;
  isComplete: boolean;
  timestamp: string;
  role: 'user' | 'assistant';
  files?: FileDTO[];
}

export interface GeneratedOption {
  title: string;
  description: string;
  selected?: boolean;
}
export interface GenerateOptionsResponse {
  competency: string;
  strand: string;
  level: number;
  gi: string;
  options: GeneratedOption[];
}

export interface GlaiMessageDTO {
  id: number;
  glai_conversation_id: number;
  role: string;
  text: string;
  full_message: string;
  glai_payload: string;
  created_at: number;
  updated_at: number;
  is_deleted: BooleanNumber;
  user_feedback: AIUserFeedback | null;
}

export enum AIUserFeedback {
  THUMBS_UP = 'thumbs_up',
  THUMBS_DOWN = 'thumbs_down',
}

export interface GlaiUserFeedbackPayload {
  user_feedback: AIUserFeedback;
  message_text: string;
  role: 'assistant' | 'user';
}
